const getUrlResource = (context: Window = window) => {
    const { pathname, search, hash } = context.location;
    return [pathname, search, hash].join('');
};

export default getUrlResource;
